<template>
  <div class="row reverse-mobile">
    <UserMenu></UserMenu>

    <div class="col-12 col-md-9">
      <div class="row">
        <div class="card w-100">
          <div class="card-body">
            <div class="d-flex flex-row align-items-center">
              <i class="material-icons material-icons-title mr-2"
                >insert_chart</i
              >
              <h3 class="card-title mt-2">Edit Scenario</h3>
            </div>

            <div
              class="d-none d-md-flex justify-content-between align-items-center"
            >
              <div class="py-4 pr-5">
                <h4 class="card-title">{{ name }}</h4>
                <p class>{{ description }}</p>
              </div>
              <img v-bind:src="deviceThumb.deviceThumb" v-bind:alt="name" />
            </div>

            <div class="form-group mb-0">
              <form
                enctype="multipart/form-data"
                method="post"
                name="form"
                @submit.prevent="save"
              >
                <div class="alert alert-danger" v-if="errorFound">
                  <strong>Whoops!</strong> We had some trouble updating your
                  scenario.
                </div>

                <h5>Decription:</h5>
                <textarea
                  @change="formChanged"
                  type="text"
                  name="description"
                  id="description"
                  v-model="description"
                  class="form-control mb-3"
                  maxlength="200"
                />

                <h5>Patient Age Class:</h5>
                <select
                  @change="formChanged"
                  class="form-control mb-3"
                  name="patient-age"
                  id="patient-age"
                  v-model="patientAge"
                >
                  <option disabled>Select</option>
                  <option
                    v-for="(patientAgeOption, idx) in patientAgeOptions"
                    :value="patientAgeOption.value"
                    :key="idx"
                    >{{ patientAgeOption.text }}</option
                  >
                </select>
                <h5>Patient Condition:</h5>
                <select
                  @change="formChanged"
                  name="patient-condition"
                  id="patient-condition"
                  v-model="patientCondition"
                  class="form-control mb-3"
                >
                  <option disabled>Select</option>
                  <option value="0" :key="0">Stable</option>
                  <option value="1" :key="1">Deteriorating</option>
                  <option value="2" :key="2">Cardiac Arrest</option>
                </select>

                <h5>Tags:</h5>
                <TagSelector
                  @change="formChanged"
                  @tag-selection-updated="tagsUpdated"
                  :availableTags="getAvailableTags"
                  :startingTags="getStartingTags"
                ></TagSelector>

                <div class="div d-flex mt-4" v-if="isMyScenario">
                  <button
                    class="btn btn-primary d-flex align-items-center justify-content-center w-25"
                    type="submit"
                    name="edit"
                  >
                    <i class="material-icons">save</i> Save Changes
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger d-flex align-items-center justify-content-center w-25 ml-2"
                    v-on:click="DeleteScenario()"
                  >
                    <i class="material-icons">delete</i> Delete Scenario
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TagSelector from "../components/TagSelector";
import UserMenu from "../components/UserMenu";
import scenService from "../services/scenarios.service";
import ScenarioHelper from "../utils/scenario.helper";

export default {
  name: "EditScenario",
  components: {
    TagSelector,
    UserMenu,
  },

  computed: {
    deviceThumb() {
      return {
        deviceThumb: require("../assets/device/" +
          ScenarioHelper.getFilenameForDeviceThumb(this.deviceId)),
      };
    },
    isMyScenario() {
      if (!this.contributedBy) return false;
      return this.$store.getters.getUser.id === this.contributedBy.id;
    }
  },

  data: function() {
    return {
      unsavedChanges: false,
      scenarioUpdated: false,
      errorFound: false,
      description: "",
      name: "",
      patientAge: null,
      patientCondition: null,
      contributedBy: null,
      availableTags: [],
      selectedTags: [],
      deviceId: 0,
      patientAgeOptions: [
        { text: "Neonate", value: 0 },
        { text: "Paediatric", value: 1 },
        { text: "Adult", value: 2 },
      ],
    };
  },
  methods: {
    getAvailableTags() {
      return scenService.scenarioTags();
    },
    getStartingTags() {
      return scenService.scenario(this.uuidId);
    },
    init() {
      this.uuidId = this.$route.params.uuidId;
      scenService.scenario(this.uuidId).then((data) => {
        this.description = data.description;
        this.patientAge = data.patient_age;
        this.patientCondition = data.patient_condition;
        (data.tags || [])
          .filter((tag) => tag)
          .forEach((tag) => this.selectedTags.push(tag.id));
        this.name = data.name;
        this.contributedBy = data.contributed_by;
        this.deviceId = data.device_id;
        this.setRouteParams("Edit Scenario: " + this.name);
      });
    },
    setRouteParams(param) {
      this.$route.meta.breadcrumb.label = param;
      this.$router.replace({ query: { temp: Date.now() } });
      this.$router.replace({ query: { temp: undefined } });
    },

    formChanged() {
      this.unsavedChanges = true;
    },

    save() {
      const swalWithBootstrapButtons = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      this.scenarioUpdated = false;
      this.errorFound = false;
      let data = {
        description: this.description,
        patient_age: this.patientAge,
        patient_condition:
          this.patientCondition === null ? null : +this.patientCondition,
        tags: this.selectedTags,
      };

      scenService
        .editScenario(data, this.uuidId)
        .then((data) => {
          swalWithBootstrapButtons.fire(
            "Updated!",
            "Your scenario has been updated.",
            "success"
          );
          this.errorFound = false;
          this.scenarioUpdated = true;
          this.unsavedChanges = false;
        })
        .catch((error) => {
          this.scenarioUpdated = false;
          this.errorFound = true;
          this.unsavedChanges = false;
        });
    },
    tagsUpdated(tags) {
      this.selectedTags = tags;
    },

    DeleteScenario() {
      const swalWithBootstrapButtons = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Delete " + this.name + "?",
          html:
            "Deleting a scenario will remove it from Community, including groups. Users who have already downloaded the scenario to their device will still have access to it.<br> <br> If you still want access to your scenario in Community you can always change its visibility to private.",
          type: "warning",
          showCancelButton: true,

          confirmButtonText: "Delete",
        })
        .then((result) => {
          if (result.value) {
            this.unsavedChanges = false;
            scenService.deleteScenario(this.uuidId).then((data) => {
              swalWithBootstrapButtons.fire(
                "Deleted!",
                "Scenario deleted.",
                "success"
              );
              this.$router.push("/me/scenarios");
            });
          }
        });
    },
  },
  beforeMount() {
    this.init();
  },
  beforeRouteLeave(to, from, next) {
    if (this.unsavedChanges) {
      const swalWithBootstrapButtons = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Leave without saving changes?",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Continue",
        })
        .then((result) => {
          if (result.value) {
            next();
          }
          next(false);
        });
    } else {
      next();
    }
  },
};
</script>

<style scoped>
img {
  max-height: 150px;
  width: auto;
}

textarea {
  height: 100px;
}
</style>
